import { useGetGuestsiteRegistryQuery } from './RegistryList.graphql.generated';
import { useIsCurrentPageSsrFetchEnabled } from '@apps/guest/shared/hooks/useIsCurrentPageSsrFetchEnabled';

export const useFetchRegistryListData = (eventHandle: string, skip?: boolean) => {
  const isSsrEnabled = useIsCurrentPageSsrFetchEnabled(eventHandle, 'registry');

  const { data, loading } = useGetGuestsiteRegistryQuery({
    variables: { eventHandle },
    batchMode: 'fast',
    fetchPolicy: 'cache-and-network',
    ssr: isSsrEnabled,
    skip,
  });

  return { data, loading };
};
